function validateEmail(email) {
    var re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
    
    return re.test(email);
}

function detectMobile() {
	if (jQuery(window).width() <= 992) {
		return true;
	}

	return false;
}